import { PrimitiveObject } from "./PrimitiveObject";
import { Line, LineSegments, Material as ThreeMaterial, Points } from "three";
import { constructLineMaterial, constructMeshThreeMaterial, constructPointsThreeMaterial } from "./BaseObject";
// TODO: Known Issue - Adding/removing the 'pickingUserId' array from the mesh (set to undefined) is not being handled
//       currently
export class MeshObject extends PrimitiveObject {
    constructor(object, type, objectId, mesh) {
        super(object);
        this.object = object;
        this.type = type;
        this.id = objectId;
        this.mesh = mesh;
    }
    getBoundingVolume() {
        this.object.updateMatrix();
        if (this.object.geometry.boundingSphere === null) {
            throw new Error("Mesh bounding sphere not generated. This is an internal bug.");
        }
        const sphere = this.object.geometry.boundingSphere.clone().applyMatrix4(this.object.matrix);
        return [sphere.center.x, sphere.center.y, sphere.center.z, sphere.radius];
    }
    constructMaterial(material) {
        const threeMaterial = this.object.material;
        const userIdChannel = this.mesh !== undefined && this.mesh.pickingUserId !== undefined;
        if (this.object instanceof Points) {
            this.object.material = constructPointsThreeMaterial(material, threeMaterial.clippingPlanes, this.id, userIdChannel);
        }
        else if (this.object instanceof LineSegments || this.object instanceof Line) {
            this.object.material = constructLineMaterial(material, threeMaterial.clippingPlanes, this.id, userIdChannel);
        }
        else {
            this.object.material = constructMeshThreeMaterial(material, threeMaterial.clippingPlanes, this.id, userIdChannel, false);
        }
    }
    getObjectType() {
        return this.type;
    }
    get isTransparent() {
        if (this.object.material instanceof ThreeMaterial) {
            return this.object.material.opacity < 1 && this.object.material.transparent;
        }
        return false;
    }
}
